export default "__VITE_ASSET__Bina51VT__"